import { merge, get, forEach } from 'lodash';
import { Language } from './language';

// TODO move away from provider
export class Translate {
  constructor(
    private language: Language,
    private translateProvider: TranslateProvider,
  ) {
    'ngInject';
  }

  /**
   * drop in replacement for {@link
   * https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate#methods_instant
   * $translate.instant}, simplified to only first argument
   * @param {string} key
   * translation key
   * @param {object} variables
   * Variables to be replaced in the translation
   * @return {string}
   * Translation for the key, or the key itself if translation is missing.
   */
  instant(key: string, variables?: object): string {
    let currentTranslations;

    if (
      angular.isDefined(
        this.translateProvider.allTranslations[this.language.current],
      )
    ) {
      currentTranslations =
        this.translateProvider.allTranslations[this.language.current];
    } else {
      currentTranslations = this.translateProvider.allTranslations['nl-nl'];
    }

    let translatedKey = get(currentTranslations, key, '');

    if (translatedKey === '') {
      translatedKey = get(this.translateProvider.defaultTranslations, key, key);
    }

    if (translatedKey === '') {
      translatedKey = key;
    }

    if (variables) {
      forEach(variables, (value, key) => {
        translatedKey = translatedKey.replace(`{{${key}}}`, value);
      });
    }

    return translatedKey;
  }
}

/**
 * Configuration for translate service, allows for adding new keys in the config phase.
 */
export class TranslateProvider {
  public readonly allTranslations: object;
  public readonly defaultTranslations: object;

  constructor() {
    this.allTranslations = {
      // supported i18n list
      // we use angular.copy; so the object on the webpack side is not overriden during tests
      'nl-nl': angular.copy(require('../../translations/nl-nl.json')),
      'en-gb': angular.copy(require('../../translations/en-gb.json')),
      'fr-fr': angular.copy(require('../../translations/fr-fr.json')),
      'de-de': angular.copy(require('../../translations/de-de.json')),
      'it-it': angular.copy(require('../../translations/it-it.json')),
      'es-es': angular.copy(require('../../translations/es-es.json')),
      'nb-no': angular.copy(require('../../translations/nb-no.json')),
      'da-dk': angular.copy(require('../../translations/da-dk.json')),
      'sv-se': angular.copy(require('../../translations/sv-se.json')),
      'fi-fi': angular.copy(require('../../translations/fi-fi.json')),
    };
    this.defaultTranslations = this.allTranslations['en-gb'];
  }

  /**
   * drop in replacement for {@link
   * https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translateProvider#methods_translations
   * $translateProvider.translations}
   * @param {string} langKey
   * A language key.
   * @param {object} translationTable
   * A plain old JavaScript object that represents a translation table.
   * @returns {Void} returns nothing
   */
  translations(langKey: string, translationTable: object): void {
    if (angular.isString(langKey) && angular.isObject(translationTable)) {
      // add language if it's missing
      if (angular.isUndefined(this.allTranslations[langKey])) {
        this.allTranslations[langKey] = {};
      }

      merge(this.allTranslations[langKey], translationTable);
    }
  }

  /**
   * Drop in replacement for {@link
   * https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate $translate}
   * meant to be removed as soon as v6 is upgrade to ng1.2+ & can use original one
   */
  // Method for instantiating
  // @ngInject
  $get(language): Translate {
    const translate = new Translate(language, this);
    return translate;
  }
}
